import { Translation } from 'cng-common/features/translations'
import { IColumn } from 'core-components/library/list/types'
import { getFormatDate } from 'core/classes/helpers/DateHelper'

import { MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS } from '../../../configs/translations'
import { IMarketYoyGrowthLogEntry } from '../../../model/types'

const KEYS = MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS

export const getColumns = (): IColumn<IMarketYoyGrowthLogEntry>[] => [
  {
    field: 'created',
    title: KEYS.log.timestamp,
    titleRender: () => <Translation text={KEYS.log.timestamp} span />,
    renderFunction: ({ created }) => <>{getFormatDate(new Date(created), 'full')}</>,
  },
  {
    field: 'modifiedBy',
    title: KEYS.log.user,
    titleRender: () => <Translation text={KEYS.log.user} span />,
  },
  {
    field: 'command',
    title: KEYS.log.event,
    titleRender: () => <Translation text={KEYS.log.event} span />,
  },
  {
    field: 'changeLog',
    title: KEYS.log.change,
    titleRender: () => <Translation text={KEYS.log.change} span />,
  },
  {
    field: 'rtm',
    title: KEYS.log.rtm,
    titleRender: () => <Translation text={KEYS.log.rtm} span />,
  },
  {
    field: 'metric',
    title: KEYS.log.metric,
    titleRender: () => <Translation text={KEYS.log.metric} span />,
  },
  {
    field: 'market',
    title: KEYS.log.market,
    titleRender: () => <Translation text={KEYS.log.market} span />,
  },
  {
    field: 'category',
    title: KEYS.log.category,
    titleRender: () => <Translation text={KEYS.log.category} span />,
    renderFunction: ({ category }) => {
      if (category.startsWith('jbp')) {
        return <Translation text={category} span />
      }

      return <>{category}</>
    },
  },
]
